// src/components/SearchCips/FilterList.jsx
import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const FilterList = React.memo(
  ({
    filterList,
    expandedAreas,
    handleClick,
    groupedPeople,
    setCurrentCip,
    currentCip,
    setIsSidebarOpen,
    query,
  }) => {
    // When searching: show only categories with matching results
    // When not searching: show all categories from filterList (excluding "all")
    const areasToRender = query
      ? Object.keys(groupedPeople).sort()
      : filterList.filter((a) => a !== "all");

    return (
      <div className="mt-6">
        {areasToRender.map(
          (area) =>
            area && (
              <div key={area} className="mb-2 font-medium">
                {/* Category Header */}
                <button
                  type="button"
                  className={`flex items-center w-full focus:outline-none py-2 pl-4 text-left ${
                    expandedAreas.has(area)
                      ? "font-semibold bg-white"
                      : "rounded-lg text-zinc-600 hover:bg-zinc-200/70 bg-zinc-100"
                  }`}
                  onClick={() => handleClick(area)}
                >
                  <motion.svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-5 h-5 mr-2 text-violet-400"
                    animate={{
                      rotate: expandedAreas.has(area) ? 0 : 180,
                      opacity: expandedAreas.has(area) ? 1 : 0.3,
                    }}
                    transition={{ duration: 0.2, ease: "easeInOut" }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M9.47 6.47a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 8.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06l4.25-4.25Z"
                      clipRule="evenodd"
                    />
                  </motion.svg>
                  <span className="text-left">{area}</span>
                </button>
                {/* Subcategories - per-category CIPs */}
                <AnimatePresence initial={false}>
                  {expandedAreas.has(area) && groupedPeople[area] && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.1, ease: "easeOut" }}
                      className="overflow-hidden"
                    >
                      <ul className="ml-6">
                        {groupedPeople[area].map((project) => (
                          <li key={project.cipCode} className="last:mb-7">
                            <button
                              onClick={() => {
                                setCurrentCip(project.cipCode);
                                setIsSidebarOpen(false);
                              }}
                              title={project.cipcodeName}
                              className={`text-sm py-2 w-full truncate border-l pl-4 tracking-tight px-2 flex items-center ${
                                project.cipCode === currentCip
                                  ? "text-indigo-600 border-indigo-500 bg-indigo-50 rounded-r-full"
                                  : !project.offered
                                  ? "text-zinc-600/70 border-gray-300 hover:border-zinc-300 hover:text-zinc-600 hover:bg-zinc-100 rounded-r-full"
                                  : "text-zinc-800 border-violet-300 hover:border-zinc-300 hover:text-black active:text-indigo-600 hover:bg-zinc-50 rounded-r-full"
                              }`}
                            >
                              <span className="tabular-nums text-xs font-light">
                                {project.cipCode}
                              </span>
                              <span className="mx-1"> </span>
                              <span className="truncate">{project.cipcodeName}</span>
                            </button>
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            )
        )}
      </div>
    );
  }
);

export default FilterList;
